import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import curved9 from "assets/images/mainSiteBackground.jpg"
import "assets/css/Animations.css";

import theme from "assets/theme";
import CoverLayout from "components/CoverLayout";
import SoftBox from "components/SoftBox";
import {useState} from "react";
import {Vortex} from "react-loader-spinner";
import FindOrder from "steps/FindOrder";
import BasicLayout from "../components/BasicLayout";
import ChooseProduct from "./ChooseProducts";
import WiderrufSuccess from "./Widerruf";

const Main = ({token, data}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [order, setOrder] = useState(undefined);
    const [submittedStatus, setSubmittedStatus] = useState(undefined);

    const loadingScene = () => (<SoftBox display="flex" justifyContent="center">
        <div className='pulse'>
            <Vortex
                visible={true}
                height="80"
                width="80"
                ariaLabel="vortex-loading"
                colors={['#ffd6ff', '#e7c6ff', '#c8b6ff', '#b8c0ff', '#bbd0ff', '#cae9ff']}
            />
        </div>
    </SoftBox>)

    const orderFound = order && Object.keys(order).length > 0;

    // Schritt 2 (versendet/nicht versendet) — eigene Karte im BasicLayout.
    if (orderFound && submittedStatus === undefined) {
        return <ThemeProvider theme={theme}>
            <CssBaseline/>
            <BasicLayout title={undefined} description={undefined} color='primary' token={token}>
                <ChooseProduct order={order} token={token} data={data} onSubmitted={setSubmittedStatus}/>
            </BasicLayout>
        </ThemeProvider>
    }

    return <ThemeProvider theme={theme}>
        <CssBaseline/>
        <CoverLayout
            title={submittedStatus !== undefined ? "Widerruf eingegangen" : "Vertrag widerrufen"}
            color='primary'
            description={submittedStatus !== undefined
                ? "Vielen Dank. Den Rest erledigen wir."
                : "Über dieses Portal kannst du deinen Kaufvertrag widerrufen. Wir benötigen nur einige Angaben zu dir und deiner Bestellung."}
            image={data?.background ?? curved9}
            logo={data?.logo ?? ''}
            token={token}
        >
            {isLoading
                ? loadingScene()
                : (submittedStatus !== undefined
                    ? <WiderrufSuccess status={submittedStatus} email={order?.email}
                                       hasExternalItems={(order?.products ?? []).some(p => p.disabled)}/>
                    : <FindOrder onSearch={setIsLoading} setOrder={setOrder} token={token}
                                 onSubmitted={setSubmittedStatus}/>)}
        </CoverLayout>
    </ThemeProvider>
}

export default Main;
